/** audiowaveform v2 JSON, as produced by the worker (see D2). */
export interface PeaksData {
  version: number;
  channels: number;
  sample_rate: number;
  samples_per_pixel: number;
  bits: number;
  length: number;
  /** Interleaved min/max pairs. */
  data: number[];
}

export async function fetchPeaks(url: string): Promise<PeaksData> {
  const response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) throw new Error(`peaks request failed: ${response.status}`);
  return (await response.json()) as PeaksData;
}

/** Full-scale value for the bit depth the file was written at. */
export function fullScale(peaks: PeaksData): number {
  return 2 ** (peaks.bits - 1);
}

/**
 * Peaks together with the point in the file they start from.
 *
 * The stored waveform covers a whole segment and begins at zero; a windowed
 * read covers a few seconds and begins wherever it was asked for. Carrying the
 * offset lets the renderer treat both the same way.
 */
export interface PeaksSource {
  data: PeaksData;
  fromSec: number;
}

export async function fetchWindowPeaks(
  segmentId: number,
  fromSec: number,
  durationSec: number,
  pixels: number,
  signal?: AbortSignal,
): Promise<PeaksData> {
  const url =
    `/api/v1/segments/${segmentId}/peaks/window`
    + `?from=${fromSec.toFixed(3)}&duration=${durationSec.toFixed(3)}&pixels=${Math.round(pixels)}`;
  const response = await fetch(url, {
    credentials: 'same-origin',
    ...(signal ? { signal } : {}),
  });
  if (!response.ok) throw new Error(`window peaks failed: ${response.status}`);
  return (await response.json()) as PeaksData;
}
